import { render, staticRenderFns } from "./Follower.vue?vue&type=template&id=60e51eba&"
import script from "./Follower.vue?vue&type=script&lang=js&"
export * from "./Follower.vue?vue&type=script&lang=js&"
import style0 from "./Follower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports